const proposalServiceTypes = Object.freeze({
  Educational: 1,
  EvaluationAndOrTherapyRelatedServices: 2,
  EducationalAndRelatedServices: 6,
  ReevaluationServices: 7,
});

export default proposalServiceTypes;
